function PhoneInfo() {
  return (
    <div className="flex flex-col items-center maxcont">
	 
      <span className="font-bold text-[#0b85a4] text-[10px] lg:text-[12px]">+38 (067) 474-46-93</span>
      <span className="font-bold text-[#0b85a4] text-[10px] lg:text-[12px]">+38 (098) 109-49-39</span>
	  {/*   <span className="font-bold text-[#0b85a4] text-[10px] lg:text-[12px]">+38 (032) 232-42-61</span> */}
    </div>
  );
}

export default PhoneInfo;
